import { useState } from 'react';
import { QuestionClient, QuestionDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useQuestionApi = () => {
    const apiClient = new QuestionClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: QuestionDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createQuestion(data);
        } catch (err: any) {
            setError(err.message || 'Error creating Question');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: QuestionDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateQuestion(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating Question');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getQuestionById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching Question');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchQuestions(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching Questions');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteQuestion(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting Question');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};